export default __webpack_public_path__ + "static/media/Alim2y.293311e0.png";